import { extractUniDataTableRows } from '@/common/utils/extractUniDataTableRows'
import { isUniDataTableFieldShape } from '@/common/utils/omitEmptyUniDataTableFieldsFromReloadPayload'

export function normalizeReloadPanelTableField(value: unknown): unknown {
  if (!isUniDataTableFieldShape(value)) return value
  const rows = extractUniDataTableRows(value)
  if (rows.length === 0) return value
  if (!value || typeof value !== 'object' || Array.isArray(value)) return value
  const typed = value as { type?: unknown; value?: Record<string, unknown> }
  if (typed.value && typeof typed.value === 'object') {
    const nextValue = { ...typed.value, rows: typed.value.rows ?? rows }
    delete (nextValue as { empty?: unknown }).empty
    return { ...typed, value: nextValue }
  }
  return value
}

export function applyReloadPanelFieldsToChangedData(
  changedData: unknown,
  reloadFields: Record<string, unknown>,
): unknown {
  if (!reloadFields || typeof reloadFields !== 'object' || Object.keys(reloadFields).length === 0) {
    return changedData
  }

  if (changedData == null || typeof changedData !== 'object' || Array.isArray(changedData)) {
    return {
      fields: {
        fields: { ...reloadFields },
      },
    }
  }

  const root = changedData as Record<string, unknown>
  const fieldsWrapper =
    root.fields && typeof root.fields === 'object' && !Array.isArray(root.fields)
      ? { ...(root.fields as Record<string, unknown>) }
      : {}
  const innerFields =
    fieldsWrapper.fields &&
    typeof fieldsWrapper.fields === 'object' &&
    !Array.isArray(fieldsWrapper.fields)
      ? { ...(fieldsWrapper.fields as Record<string, unknown>) }
      : {}

  for (const [key, value] of Object.entries(reloadFields)) {
    innerFields[key] = normalizeReloadPanelTableField(value)
  }

  return {
    ...root,
    fields: {
      ...fieldsWrapper,
      fields: innerFields,
    },
  }
}
